// extracted by mini-css-extract-plugin
export default {"modalTitle":"@gscope-mfe-common-components__src-components-ModalDialog-___ModalDialog-module__modalTitle___S2DZi"};